<div class="wrapper wrapper-full-page">
  <div class="full-page">
    <router-outlet></router-outlet>
  </div>
</div>
